// src/components/ui/Meta.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const Meta = ({ title, description, keywords, canonicalUrl }) => {
  const location = useLocation();
  // Ensure the base URL is correctly formed, especially for client-side routing
  const currentUrl = canonicalUrl || `${window.location.origin}${location.pathname}`;

  return (
    <Helmet>
      <title>{title || 'Your Default Title'}</title>
      <meta name="description" content={description || 'Your default description.'} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

export default Meta;
